module.exports = __webpack_public_path__ + "static/media/galaxy_low.834e9646.jpg";